import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
  navItems = [
    {
      label: 'Dashboard',
      icon: '../../../assets/icons/home.svg',
      active: '../../../assets/icons/home-active.svg',
    },
    {
      label: 'Customers',
      icon: '../../../assets/icons/customer.png',
      active: '../../../assets/icons/customer-active.png',
    },
    {
      label: 'Rewards',
      icon: '../../../assets/icons/reward.png',
      active: '../../../assets/icons/reward-active.png',
    },
    {
      label: 'API Keys',
      icon: '../../../assets/icons/key.svg',
      active: '../../../assets/icons/key-active.svg',
    },
  ];
  activeItem = this.navItems[0].label;
  isToggled: boolean = false;
  @Input() isMobileSideNav: boolean = false;
  @Output() toggleEvent = new EventEmitter<boolean>();
  constructor(private router: Router) {this.checkScreenWidth()}
  ngOnInit() {
    const currentUrl = this.router.url.slice(1);
    const matchedItem = this.navItems.find(
      (item) => this.formatString(item.label) === currentUrl
    );
    if (matchedItem) {
      this.activeItem = matchedItem.label;
    }
    const savedState = localStorage.getItem('isToggled');
    this.isToggled = savedState === 'true';
  }
  closeMobileSidenav=()=>{this.isMobileSideNav = false; console.log('sidenav', this.isMobileSideNav)}
  openMobileSidenav=()=>{this.isMobileSideNav = true}
  setActiveItem(item: string) {
    this.activeItem = item;
    const url = this.formatString(item);
    this.router.navigate([`/${url}`]);
  }
  formatString(input: string) {
    return input.toLowerCase().replace(/\s+/g, '-');
  }
  getIcon(item: any): string {
    return this.activeItem === item.label ? item.active : item.icon;
  }
  toggleSideBar = () => {
    this.isToggled = !this.isToggled;
    this.toggleEvent.emit(this.isToggled);
    localStorage.setItem('isToggled', String(this.isToggled));
  };
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenWidth();
  }
  checkScreenWidth() {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 800) {
      this.isToggled = true;
      this.toggleEvent.emit(this.isToggled);
      localStorage.setItem('isToggled', String(this.isToggled));
    } else {
      this.isToggled = false;
      this.toggleEvent.emit(this.isToggled);
    }
  }
}
